<button
  type="button"
  class="tf-mention-chip"
  [class.tf-mention-chip--deleted]="mention().isDeleted"
  [attr.aria-label]="
    (mention().isDeleted
      ? 'COMMENTS.MENTIONS.CHIP_ARIA_DELETED'
      : 'COMMENTS.MENTIONS.CHIP_ARIA'
    ) | translate: { name: displayLabel() }
  "
  [attr.title]="
    (mention().isDeleted
      ? 'COMMENTS.MENTIONS.CHIP_ARIA_DELETED'
      : 'COMMENTS.MENTIONS.CHIP_ARIA'
    ) | translate: { name: displayLabel() }
  "
  (click)="onChipClick($event)">
  &#64;{{ displayLabel() }}
</button>

<p-popover #op (onShow)="onPopoverShow()" appendTo="body">
  <div class="tf-mention-chip__popover">
    @if (mention().isDeleted) {
      <div class="tf-mention-chip__row tf-mention-chip__name">
        {{ 'COMMENTS.MENTIONS.DELETED_TITLE' | translate }}
      </div>
      <div class="tf-mention-chip__row tf-mention-chip__muted">
        {{ 'COMMENTS.MENTIONS.DELETED_DETAIL' | translate: { name: mention().displayName } }}
      </div>
    } @else if (loading()) {
      <div class="tf-mention-chip__row tf-mention-chip__loading">
        <p-progressspinner styleClass="tf-mention-chip__spinner" />
        <span class="sr-only">{{ 'GENERAL.LOADING' | translate }}</span>
      </div>
    } @else if (errored() || detail() === null) {
      <!-- Fallback when the lazy load failed entirely — show the cached chip label so the
           popover is never empty. -->
      <div class="tf-mention-chip__row tf-mention-chip__name">
        &#64;{{ mention().displayName }}
      </div>
    } @else {
      <div class="tf-mention-chip__row tf-mention-chip__name">{{ detail()!.displayName }}</div>
      @if (detail()!.email) {
        <div class="tf-mention-chip__row tf-mention-chip__email">
          <i class="pi pi-envelope" aria-hidden="true"></i>
          <a [href]="'mailto:' + detail()!.email">{{ detail()!.email }}</a>
        </div>
      }
      @if (detail()!.roles && detail()!.roles.length > 0) {
        <div class="tf-mention-chip__row tf-mention-chip__roles">
          <span class="tf-mention-chip__roles-label">
            {{ 'COMMENTS.MENTIONS.ROLES_LABEL' | translate }}
          </span>
          <span class="tf-mention-chip__roles-list">{{ detail()!.roles.join(', ') }}</span>
        </div>
      }
    }
  </div>
</p-popover>
